/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ApprenantAzureSearch
 */
export interface ApprenantAzureSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantAzureSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {number}
     * @memberof ApprenantAzureSearch
     */
    idApprenant?: number;
    /**
     * 
     * @type {string}
     * @memberof ApprenantAzureSearch
     */
    codeCentres?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprenantAzureSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ApprenantAzureSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantAzureSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantAzureSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ApprenantAzureSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantAzureSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ApprenantAzureSearch interface.
 */
export function instanceOfApprenantAzureSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantAzureSearchFromJSON(json: any): ApprenantAzureSearch {
    return ApprenantAzureSearchFromJSONTyped(json, false);
}

export function ApprenantAzureSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantAzureSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'codeCentres': !exists(json, 'codeCentres') ? undefined : json['codeCentres'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ApprenantAzureSearchToJSON(value?: ApprenantAzureSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'centre': TextSearchToJSON(value.centre),
        'idApprenant': value.idApprenant,
        'codeCentres': value.codeCentres,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

